/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSouscriptionWaiverStagesQuery = gql`
  query GetSouscriptionWaiverStagesQuery {
    getSouscriptionWaiverStages_souscription_waiver_stages {
      offer {
 effectDate  
packs {
 id  
customerId  
granteeId  
externalId  
pricings {
 id  
isSelected  
moduleLabel  
moduleCode  
supplementaryCover  
availableWaiverRequests  
waiverRequests {
 code  
textInformations  
textInformation  
} 
isLinkedToDiscountProduct  
stage  
isLinkedToStageProduct  
} 
} 
}
    }
  }
`;

export default GetSouscriptionWaiverStagesQuery;
